// Compute a human-readable age (PT) from an ISO birthdate (YYYY-MM-DD).
// Returns the current age as of today; never stale.
export function computeIdadeFromDataNascimento(dataNascimento) {
  if (!dataNascimento) return '';
  const iso = dataNascimento.slice(0, 10);
  const parts = iso.split('-');
  if (parts.length !== 3) return '';
  const birth = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(birth.getTime())) return '';
  const now = new Date();
  let years = now.getFullYear() - birth.getFullYear();
  let months = now.getMonth() - birth.getMonth();
  if (now.getDate() < birth.getDate()) months--;
  if (months < 0) { years--; months += 12; }
  if (years < 0) { years = 0; months = 0; }
  if (years < 1) {
    const totalMonths = Math.max(0, months);
    if (totalMonths === 0) {
      // less than one month — show days
      const diffMs = now - birth;
      const dias = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24)));
      return `${dias} ${dias === 1 ? 'dia' : 'dias'}`;
    }
    return `${totalMonths} ${totalMonths === 1 ? 'mês' : 'meses'}`;
  }
  if (months === 0) return `${years} ${years === 1 ? 'ano' : 'anos'}`;
  return `${years} ${years === 1 ? 'ano' : 'anos'} e ${months} ${months === 1 ? 'mês' : 'meses'}`;
}

// Given an animal document, prefer computing from birthdate (always current);
// fall back to whatever was stored in `idade`.
export function idadeDoAnimal(animal) {
  if (!animal) return '';
  if (animal.data_nascimento) return computeIdadeFromDataNascimento(animal.data_nascimento);
  return animal.idade || '';
}
